(() => {
  const initMenu = () => {
    document.querySelectorAll("[data-mc-header]").forEach((header) => {
      if (header.dataset.menuReady === "true") return;

      const toggle = header.querySelector("[data-mc-nav-toggle]");
      const nav = header.querySelector("[data-mc-nav]");

      if (!toggle || !nav) return;

      header.dataset.menuReady = "true";

      const setOpen = (isOpen) => {
        header.toggleAttribute("data-nav-open", isOpen);
        toggle.setAttribute("aria-expanded", String(isOpen));
        document.body.classList.toggle("mc-nav-is-open", isOpen);
      };

      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        setOpen(!header.hasAttribute("data-nav-open"));
      });

      nav.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", () => setOpen(false));
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") setOpen(false);
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMenu);
  } else {
    initMenu();
  }

  document.addEventListener("shopify:section:load", initMenu);
})();
